import { Link } from "react-router-dom";

export default function BillingCancelledPage() {
  return (
    <div className="min-h-screen bg-background-100 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center mx-auto mb-5">
          <i className="ri-close-circle-line text-foreground-400 text-3xl"></i>
        </div>
        <h1 className="text-foreground-900 text-xl font-bold mb-2">Checkout cancelled</h1>
        <p className="text-foreground-500 text-sm mb-6">
          No charge was made. You can pick a plan whenever you're ready.
        </p>
        <Link to="/billing" className="inline-flex h-11 px-6 bg-primary-600 hover:bg-primary-700 text-white text-sm font-semibold rounded-lg items-center justify-center transition-colors">
          Back to Billing
        </Link>
      </div>
    </div>
  );
}
